import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled, { css } from 'styled-components';
var colorSchemes = {
  grey: {
    background: '#EBEBEB',
    textColor: '#898989'
  },
  green: {
    background: '#E4FBE5',
    textColor: '#4AC326'
  },
  red: {
    background: '#FDEBEB',
    textColor: '#FD4949'
  },
  blue: {
    background: '#EBEEFD',
    textColor: '#1F35B5'
  },
  white: {
    background: '#FFF',
    textColor: '#1F35B5'
  }
};
var variants = {
  md: {
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 5,
    paddingRight: 5
  },
  lg: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 5,
    paddingRight: 5
  }
};
export var BadgeWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: 'Ubuntu';\n  border-radius: 5px;\n  border: 1px solid transparent;\n\n  display: flex;\n  align-items: center;\n\n  gap: 10px;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var colorScheme = _ref.colorScheme;
  return colorScheme && colorSchemes[colorScheme] && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: max-content;\n    color: ", ";\n    background: ", ";\n  "])), colorSchemes[colorScheme].textColor, colorSchemes[colorScheme].background);
}, function (_ref2) {
  var border = _ref2.border;
  return border && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border: 1px solid #1F35B5;\n  "])));
}, function (_ref3) {
  var rounded = _ref3.rounded;
  return rounded && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border-radius: 9999px;\n  "])));
}, function (_ref4) {
  var variant = _ref4.variant,
      icon = _ref4.icon;
  return variant && variants[variant] && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding-right: ", "px;\n    padding-left: ", "px;\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n  "])), variants[variant].paddingRight, icon ? variants[variant].paddingLeft + 10 : variants[variant].paddingLeft, variants[variant].paddingTop, variants[variant].paddingBottom);
});
export var IconContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: #1F35B5;\n\n  border-radius: 50%;\n\n  width: 20px;\n  height: 20px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin: 1px 2px;\n\n  cursor: pointer;\n"])));